import React from 'react';

const IconLogo = () => (
  <svg width="84" height="98" viewBox="0 0 84 98" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M42 1L1 24.4667V72.4667L42 97L83 73.5333V25.5333L42 1Z"
      fill="#64FFDA"
      stroke="#64FFDA"
    />
    <path d="M42 4L3 26V71L42 94L81 72V27L42 4Z" fill="black" stroke="#64FFDA" />
    <path
      d="M41.96 70.42C38.88 70.42 36.12 69.92 33.68 68.92C31.24 67.92 29.28 66.44 27.8 64.48C26.36 62.52 25.6 60.16 25.52 57.4H36.44C36.6 58.96 37.14 60.16 38.06 61C38.98 61.8 40.18 62.2 41.66 62.2C43.18 62.2 44.38 61.86 45.26 61.18C46.14 60.46 46.58 59.48 46.58 58.24C46.58 57.2 46.22 56.34 45.5 55.66C44.82 54.98 43.96 54.42 42.92 53.98C41.92 53.54 40.48 53.04 38.6 52.48C35.88 51.64 33.66 50.8 31.94 49.96C30.22 49.12 28.74 47.88 27.5 46.24C26.26 44.6 25.64 42.46 25.64 39.82C25.64 35.9 27.06 32.84 29.9 30.64C32.74 28.4 36.44 27.28 41 27.28C45.64 27.28 49.38 28.4 52.22 30.64C55.06 32.84 56.58 35.92 56.78 39.88H45.68C45.6 38.52 45.1 37.46 44.18 36.7C43.26 35.9 42.08 35.5 40.64 35.5C39.4 35.5 38.4 35.84 37.64 36.52C36.88 37.16 36.5 38.1 36.5 39.34C36.5 40.7 37.14 41.76 38.42 42.52C39.7 43.28 41.7 44.1 44.42 44.98C47.14 45.9 49.34 46.78 51.02 47.62C52.74 48.46 54.22 49.68 55.46 51.28C56.7 52.88 57.32 54.94 57.32 57.46C57.32 59.86 56.7 62.04 55.46 64C54.26 65.96 52.5 67.52 50.18 68.68C47.86 69.84 45.12 70.42 41.96 70.42Z"
      fill="#64FFDA"
    />
  </svg>
);

export default IconLogo;
